/**
 * @generated SignedSource<<cb07192db02d978b7dd55416a8e0b1db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkCompletedQrCodeValue_charge$data = {
  readonly chargeIntent: {
    readonly id: string;
  } | null | undefined;
  readonly discount: number | null | undefined;
  readonly id: string;
  readonly type: string | null | undefined;
  readonly value: number | null | undefined;
  readonly valuePaid: number | null | undefined;
  readonly valueWithDiscount: number | null | undefined;
  readonly " $fragmentType": "PaymentLinkCompletedQrCodeValue_charge";
};
export type PaymentLinkCompletedQrCodeValue_charge$key = {
  readonly " $data"?: PaymentLinkCompletedQrCodeValue_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkCompletedQrCodeValue_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkCompletedQrCodeValue_charge",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valuePaid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueWithDiscount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Charge",
      "kind": "LinkedField",
      "name": "chargeIntent",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "e719571631efafeaea8ab75f1500ac27";

export default node;
